var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.8,13.2c0.1,0.1,0.3,0.2,0.5,0.2c0,0,0,0,0,0c0.2,0,0.4-0.1,0.5-0.3c0.7-0.9,1.4-1.8,1.9-2.8 c0.1-0.2,0.1-0.5,0-0.7c-0.1-0.3-3.6-7.1-9.8-7.1c0,0,0,0,0,0c-0.6,0-1.3,0.1-1.9,0.2C7.8,2.9,7.6,3.1,7.5,3.3s0,0.5,0.2,0.7 L16.8,13.2z M10,4.1c4.6,0,7.6,4.6,8.3,5.9c-0.3,0.5-0.6,1-1,1.5L9.9,4.1C9.9,4.1,10,4.1,10,4.1z M19.7,18.6l-4.2-4.2L5.6,4.5 c0,0,0,0,0,0L1.4,0.3C1.1,0,0.6,0,0.3,0.3S0,1.1,0.3,1.4L3.9,5C2.4,6.3,1.1,7.9,0.2,9.6c-0.1,0.2-0.1,0.5,0,0.7 c0.1,0.3,3.6,7.1,9.9,7.1c1.7,0,3.4-0.5,4.9-1.5l3.8,3.8c0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2C20,19.4,20,18.9,19.7,18.6z  M8.3,9.4l2.3,2.3c-0.2,0.1-0.4,0.1-0.6,0.1c-0.2,0-0.5,0-0.7-0.1c-0.2-0.1-0.4-0.2-0.6-0.4c-0.2-0.2-0.3-0.4-0.4-0.6 c-0.1-0.2-0.1-0.5-0.1-0.7C8.2,9.8,8.2,9.6,8.3,9.4z M10,15.9c-4.6,0-7.6-4.6-8.3-5.9c0.9-1.5,2-2.8,3.3-3.9l2.2,2.2 C7.1,8.4,7,8.6,7,8.7C6.8,9.1,6.7,9.6,6.7,10c0,0.4,0.1,0.9,0.2,1.3c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.3,0.7,0.6,1.1,0.7 c0.4,0.2,0.8,0.2,1.3,0.2c0.4,0,0.9-0.1,1.3-0.3c0.2-0.1,0.3-0.2,0.5-0.3l2.1,2.1C12.6,15.5,11.3,15.9,10,15.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.c3f1962d3ee2672242165fb909ccead1.svg";
export { ForwardRef as ReactComponent };